module.exports = __webpack_public_path__ + "static/images/cover_C7.45bc024.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover/cover_C7.png
// module id = LvK1
// module chunks = 8